import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-emp-team',
  templateUrl: './skeleton-emp-team.component.html',
  styleUrls: ['./skeleton-emp-team.component.scss'],
  standalone: false
})
export class SkeletonEmpTeamComponent implements OnInit {
  dummydata: any = ['','','','','','','','',''];
  constructor() { }

  ngOnInit() {}

}
